import { Component, OnDestroy, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import Keycloak from 'keycloak-js';
import { setupKeycloakFrontChannelLogoutListener } from '@ekowitryna/ui';
import { PwaUpdateService } from './core/services/pwa-update.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly pwaUpdateService = inject(PwaUpdateService);
  private readonly translateService = inject(TranslateService);
  private readonly keycloak = inject(Keycloak);
  private readonly platformId = inject(PLATFORM_ID);
  private frontChannelLogoutCleanup?: () => void;

  constructor() {
    this.translateService.setDefaultLang('pl');
    this.translateService.use('pl');
  }

  ngOnInit(): void {
    this.pwaUpdateService.init();

    if (isPlatformBrowser(this.platformId)) {
      this.frontChannelLogoutCleanup = setupKeycloakFrontChannelLogoutListener(this.keycloak);
    }
  }

  ngOnDestroy(): void {
    this.frontChannelLogoutCleanup?.();
  }
}
